import { DashboardMarksModel as Model } from './Model'


export const MODULE_NAME = 'dashboard-marks'

export const DASHBOARD_MARKS_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const

export const MENU = {
  id: DASHBOARD_MARKS_ROUTES.LAYOUT,
  route: { name: DASHBOARD_MARKS_ROUTES.LAYOUT },
  label: Model.page_title.index,
  icon: 'mdi-view-dashboard',
} as const
